import Record from '../Record'

export default class OpeningHours_Irregular extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			return new OpeningHours_Irregular({
				// Kezdő és végdátum
				start_d: null,
				end_d: null,

				// Nyitvatartási rend az adott napokon
				open: null,
				close: null,
				closed: 0,
				web_open: null,
				web_close: null,
				web_closed: 0
			})
		} else {
			// Load
			throw new Error('Not implemented')
		}
	}

	validation_schema = {
		open: [
			[(value, params, data) => !(data.closed == 0 && !value), {}, 'Kötelező megadni']
		],
		close: [
			[(value, params, data) => !(data.closed == 0 && !value), {}, 'Kötelező megadni']
		],
		web_open: [
			[(value, params, data) => !(data.web_closed == 0 && !value), {}, 'Kötelező megadni']
		],
		web_close: [
			[(value, params, data) => !(data.web_closed == 0 && !value), {}, 'Kötelező megadni']
		],
		start_d: [ 'required' ],
		end_d: [ 'required' ]
	}
}
